import { Check } from "lucide-react";

interface Scope {
  code: string;
  name: string;
}

interface ScopeFormProps {
  scopes: Scope[];
  selectedScopes: string[];
  toggleScope: (scopeCode: string) => void;
  loading: boolean;
}

export function ScopeForm({
  scopes,
  selectedScopes,
  toggleScope,
  loading,
}: ScopeFormProps) {
  if (loading) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Loading scopes...</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        {scopes.map((scope) => (
          <label
            key={scope.code}
            className={`
              relative flex items-center p-4 rounded-lg border cursor-pointer
              ${
                selectedScopes.includes(scope.code)
                  ? "border-indigo-500 bg-indigo-50"
                  : "border-gray-200 hover:border-gray-300"
              }
            `}
          >
            <input
              type="checkbox"
              className="sr-only"
              checked={selectedScopes.includes(scope.code)}
              onChange={() => toggleScope(scope.code)}
            />
            <div className="flex items-center justify-between w-full">
              <div className="text-sm font-medium text-gray-900">
                {scope.name}
              </div>
              {selectedScopes.includes(scope.code) && (
                <Check className="h-5 w-5 text-indigo-500" />
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
